import React from "react";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import { ReactComponent as CalendarDangerSVG } from "../../../../../../../../images/svg/subscriptions/calendar-danger.svg";
import { SubscriptionApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { splitDateWithComma } from "./SingleSubscriptionPreview";

interface Props {
	subscription: SubscriptionApi;
	className?: string;
}

const SubscriptionDate = ({ subscription, className }: Props) => {
	const { t } = useTranslation();

	const draw = () => {
		if (
			subscription.status === "CANCELLED" &&
			(subscription.cancellation_reason === "MISSING_CUSTOMER_DATA" ||
				subscription.cancellation_reason === "WAITING_PAYMENT") &&
			subscription.cancelled_at
		)
			return (
				<>
					<CalendarDangerSVG className="calendar-icon" />
					<span className="label text-danger">
						{" "}
						{t("modules.subscription.field.cancellation.title")}{" "}
						{splitDateWithComma(FormatDate(subscription.cancelled_at))}
					</span>
				</>
			);

		if (subscription.cancelled_at && subscription.status === "CANCELLED" && subscription.cancellation_reason)
			return (
				<>
					<CalendarSVG className="calendar-icon" />
					<span className="label">
						{" "}
						{t("modules.subscription.field.expired.title")}{" "}
						{splitDateWithComma(FormatDate(subscription.cancelled_at))}
					</span>
				</>
			);

		if (subscription.current_term_end && subscription.status === "ACTIVE")
			return (
				<>
					<CalendarSVG className="calendar-icon" />
					<span className="label">
						{t("lib:common.word.to")} {splitDateWithComma(FormatDate(subscription.current_term_end))}
					</span>
				</>
			);

		if (subscription.trial_end && subscription.status === "IN_TRIAL")
			return (
				<>
					<CalendarSVG className="calendar-icon" />
					<span className="label">
						{t("lib:common.word.to")} {splitDateWithComma(FormatDate(subscription.trial_end))}
					</span>
				</>
			);

		if (subscription.cancelled_at && subscription.status === "NON_RENEWING")
			return (
				<>
					<CalendarSVG className="calendar-icon" />
					<span className="label">
						{t("lib:common.word.from")} {splitDateWithComma(FormatDate(subscription.cancelled_at))}
					</span>
				</>
			);

		if (subscription.pause_date && subscription.resume_date && subscription.status === "PAUSED")
			return (
				<>
					<CalendarSVG className="calendar-icon" />
					<span className="label">
						{t("lib:common.word.from")} {splitDateWithComma(FormatDate(subscription.pause_date))}{" "}
						{t("lib:common.word.to")} {splitDateWithComma(FormatDate(subscription.resume_date))}
					</span>
				</>
			);

		return null;
	};

	return <div className={className}>{draw()}</div>;
};

export default SubscriptionDate;
